var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.47392 18.2105C3.47392 10.5471 9.33235 4.2273 16.8041 3.49221V0.00439453C7.41335 0.750593 0 8.63084 0 18.2105C0 27.7902 7.41335 35.6705 16.8041 36.4167V32.9288C9.33096 32.1938 3.47392 25.874 3.47392 18.2105Z",
    fill: "#B9B9B9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7239 0.00439453V3.49221C27.197 4.2273 33.054 10.5471 33.054 18.2105C33.054 25.874 27.1956 32.1938 19.7239 32.9288V36.4167C29.1146 35.6705 36.5279 27.7902 36.5279 18.2105C36.5279 8.63084 29.1146 0.750593 19.7239 0.00439453Z",
    fill: "#B9B9B9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.05701 17.0237H9.55594C10.1368 12.7355 13.8191 9.41997 18.2644 9.41997C22.7096 9.41997 26.3906 12.7369 26.9728 17.0237H30.4717C29.8728 10.8151 24.6272 5.94604 18.2658 5.94604C11.9043 5.94604 6.65591 10.8151 6.05701 17.0237Z",
    fill: "#B9B9B9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2648 27C13.8502 27 10.1859 23.7276 9.56751 19.4824H6.0658C6.70361 25.6493 11.9312 30.4739 18.2648 30.4739C24.5985 30.4739 29.8246 25.6493 30.4638 19.4824H26.9621C26.3438 23.7289 22.6795 27 18.2648 27Z",
    fill: "#B9B9B9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2647 12.3945C14.9908 12.3945 12.327 15.0583 12.327 18.3322C12.327 21.606 14.9908 24.2698 18.2647 24.2698C21.5385 24.2698 24.2023 21.606 24.2023 18.3322C24.2023 15.0583 21.5385 12.3945 18.2647 12.3945ZM18.2647 20.7973C16.9057 20.7973 15.8009 19.6912 15.8009 18.3335C15.8009 16.9759 16.907 15.8698 18.2647 15.8698C19.6223 15.8698 20.7284 16.9759 20.7284 18.3335C20.7284 19.6912 19.6223 20.7973 18.2647 20.7973Z",
    fill: "#B9B9B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6b5f4d3d564d5f123efa007678854eb6.svg";
export { ForwardRef as ReactComponent };